import { useMutation, useQueryClient } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import servicePlanKeys from '@/api/queries/service-plans/keyFactory';
import { graphql } from '@/gql';
import { UpdateServicePlanSubscriptionAddressInput } from '@/gql/graphql';

const UpdateServicePlanSubscriptionAddressMutation = graphql(`
  mutation UpdateServicePlanSubscriptionAddress(
    $input: UpdateServicePlanSubscriptionAddressInput!
  ) {
    updateServicePlanSubscriptionAddress(input: $input) {
      id
      address {
        id
        line1
        line2
        city
        administrativeArea
        postalCode
        country
        fullLocalAddress
      }
    }
  }
`);

const useUpdateServicePlanSubscriptionAddress = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input: UpdateServicePlanSubscriptionAddressInput) => {
      return gqlClient.request(UpdateServicePlanSubscriptionAddressMutation, {
        input,
      });
    },
    onSuccess: () => {
      return queryClient.invalidateQueries({
        queryKey: servicePlanKeys.all,
      });
    },
  });
};

export default useUpdateServicePlanSubscriptionAddress;
